import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import { Link as LinkTo } from 'react-router';
import { useMemo } from "react";
import { useObrasAlvenariaEstruturalViewModel } from "../../viewModels/obras_alvenaria_estrutural_view_model";
import { GenerateObraAlvenariaEstruturalColumns } from "./columns/obra_alvenaria_estrutural";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { AlvenariaEstruturalLista } from "../../../domain/models/plano_alvenaria_estrutural_lista";
import { AlvenariaEstruturalModal } from "./components/alvenaria_estrutural_modal";
import { Header } from "./components/header";
import { ObrasTopBar } from "../../components/obras_top_bar";
import { ObrasTopHeader } from "../../components/obras_top_header";
import { ObrasReportModals } from "../../components/obras_report_modals";

import DeleteDialog from "../../../../../common/components/delete_dialog";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";

export const ObrasAlvenariaEstrutural = () => {
  const viewModel = useObrasAlvenariaEstruturalViewModel();
  const obraAlvenariaEstruturalColumns = useMemo(() => {
    return GenerateObraAlvenariaEstruturalColumns({
      onActionEditar: viewModel.handleCadastroAlvenariaEstruturaOpenState,
      onActionDeletar: viewModel.handleDeleteOAlvenariaEstruturalModalOpenState,
    });
  }, [viewModel.handleCadastroAlvenariaEstruturaOpenState, viewModel.handleDeleteOAlvenariaEstruturalModalOpenState]);


  return (
    <>
      <ObrasTopBar
        obrasReportState={viewModel.obrasReportState}
        state={viewModel.obrasTopHeaderState}
        selectedObra={viewModel.selectedObra}
        onBack={viewModel.handleBack}
        leftBackSlotButton={
          <PrimaryButton
            startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
            onMouseDown={e => {
              viewModel.handleCadastroAlvenariaEstruturaOpenState(null, true)
              e.preventDefault();
            }}>
            Novo Item
          </PrimaryButton>
        }
      />
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Obras
            </Link>
            <Link underline="hover" color="inherit" component={'span'}>
              <LinkTo to='/Obras_lista' > Lista de Obras </LinkTo>
            </Link>
            <Typography className="text-primary-green">
              Alvenaria Estrutural
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <ObrasTopHeader
              title='Alvenaria Estrutural'
              selectedObra={viewModel.selectedObra}
              onReload={viewModel.handleReload}
            />
          </div>

          <Header
            onClearFilters={viewModel.handleClearFilters}
            handleDataReceberRangeChange={viewModel.handleDataReceberRangeChange}
            handleTipoBlocoChange={viewModel.handleTipoBlocoChange}
            handleFornecedorChange={viewModel.handleFornecedorChange}
            handleNroNotaFiscalChange={viewModel.handleNroNotaFiscalChange}
            dataReceberAte={viewModel.filters.dataReceberAte}
            dataReceberDe={viewModel.filters.dataReceberDe}
            fornecedor={viewModel.filters.Fornecedor}
            tipoBloco={viewModel.filters.TipoBloco}
            NroNotaFiscal={viewModel.filters.NroNotaFiscal}

          />

          <StyledDataGrid
            tableName="obras_treinamentos"
            disableColumnMenu={false}
            getRowId={(row: AlvenariaEstruturalLista) => row.IdAlvenariaObra}
            columns={obraAlvenariaEstruturalColumns}
            loading={viewModel.loading}
            rows={viewModel.alvenariaEstruturalLista}
            rowCount={viewModel.pagination.totalItems}
            sx={{
              '& .status-header': {
                backgroundColor: '#AFDFD5',
                color: '#000'
              }
            }}
            pageSizeOptions={[10]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }} />
          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
        </div>
      </form>

      {/* Modal */}
      <AlvenariaEstruturalModal
        open={viewModel.alvenariaEstruturaModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedAlvenariaEstrutura={viewModel.selectedAlvenariaEstrutura}
        onClose={() => viewModel.handleCadastroAlvenariaEstruturaOpenState(null, false)}
        handleDownload={viewModel.handleDownload}
        onSubmit={viewModel.handleAlvenariaEstruturalSubmit} />

      <ObrasReportModals
        state={viewModel.obrasReportState}
      />

      {/* Deletar Registro */}
      <DeleteDialog
        open={viewModel.alvenariaEstruturalDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteOAlvenariaEstruturalModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaAlvenariaEstrutural} />

    </>
  )
};
